export class GetLogin{
    UserID:number;
    Username:string;
    Unique_Ref:string;
    Password:string;
    Confirm_Password:string;
}